const React = require('react');
const GroupComponents = require('./groupComponents');

const UseFormRendererUtils = module.exports = {};

UseFormRendererUtils.renderFieldGroups = ({
    renderer,
    fieldsWrapper,
    formConfig,
    argsByMethod,
    groupProps,
    renderGroups
}) => {

    return renderGroups({
        renderer,
        fieldsWrapper,
        formConfig,
        argsByMethod,
        groupProps
    });
};

UseFormRendererUtils.buildRenderFields = ({
    renderer,
    renderGroups,
    getFormConfig = (_renderer) => _renderer.props?.formConfig
}) => {

    return ({ fieldsWrapper, argsByMethod, groupProps } = {}) => {

        return UseFormRendererUtils.renderFieldGroups({
            renderer,
            fieldsWrapper,
            formConfig: getFormConfig(renderer),
            argsByMethod,
            groupProps,
            renderGroups
        });
    };
};

UseFormRendererUtils.buildComponentGroupProps = ({
    group = {},
    groupProps = {}
}) => {
    const layoutPropKeys = [
        'columnGap',
        'columns',
        'description',
        'gap',
        'rowGap',
        'singleRowMinHeight',
        'title'
    ];

    return {
        ...groupProps,
        ...layoutPropKeys.reduce((collector, key) => {

            if (typeof group[key] !== 'undefined') {
                collector[key] = group[key];
            }

            return collector;
        }, {}),
        ...group.componentProps,
        fieldNames: group.fieldNames,
        group
    };
};

UseFormRendererUtils.resolveGroupComponent = ({
    group = {},
    groupComponents,
    groupComponentRegistry
}) => GroupComponents.resolveGroupComponent({
    type: group.type,
    component: group.component,
    components: groupComponents,
    registry: groupComponentRegistry
});

UseFormRendererUtils.renderGroup = ({
    group = {},
    groupProps,
    groupComponents,
    groupComponentRegistry
}) => {

    const Component = UseFormRendererUtils.resolveGroupComponent({
        group,
        groupComponents,
        groupComponentRegistry
    });

    if (!Component) {
        return null;
    }

    return <Component
        {...UseFormRendererUtils.buildComponentGroupProps({
            group,
            groupProps
        })}
    />;
};

UseFormRendererUtils.renderGroups = ({
    groups = [],
    groupProps,
    groupComponents,
    groupComponentRegistry
}) => groups.map((group) => <React.Fragment key={group.name}>
    {UseFormRendererUtils.renderGroup({
        group,
        groupProps,
        groupComponents,
        groupComponentRegistry
    })}
</React.Fragment>);
